import { customElement, FASTElement, observable } from '@microsoft/fast-element';
import { WatchlistContainerTemplate as template } from './watchlist.template';
import { WatchlistContainerStyles as styles } from './watchlist.styles';
import { Project, WatchlistProject } from '../../../../types';
import { logger, Message, SocketSubscription } from '@genesislcap/foundation-comms';
import { IProjectService } from '../../../../services/project.service';
import { updateArray } from '../../../../utils/dataserver';
import { Tabs } from '@microsoft/fast-foundation';

const name = 'watchlist-container';

@customElement({
  name,
  template,
  styles,
})
export class WatchlistContainer extends FASTElement {
  @IProjectService projectService: IProjectService;
  @observable selectedProject: WatchlistProject;
  @observable projectList: Array<WatchlistProject> = [];

  @observable selectedDraftProject: WatchlistProject;
  @observable vppaList: Array<WatchlistProject> = [];

  public modalTabs: Tabs;

  private watchlistSubscription: SocketSubscription;

  constructor() {
    super();
    this.streamWatchlistProjects();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.watchlistSubscription?.unsubscribe();
  }

  private streamWatchlistProjects() {
    let resultList = [];
    this.watchlistSubscription = this.projectService.getAllWatchlistProjects('').subscribe({
      next: (streamMessage: Message) => {
        resultList = streamMessage.ROW ?? null;
        if (resultList) {
          this.projectList = updateArray(resultList, this.projectList).sort(
            (a, b) => a.MODIFIED_AT - b.MODIFIED_AT
          );
        } else {
          this.projectList = [];
          const resultError = streamMessage.DETAILS?.ERROR;
          logger.error(resultError);
        }
      },
      error: (error: any) => {
        this.projectList = [];
        logger.error(error);
      },
    });
  }
}
